import React, { useEffect, useState } from "react";
import { api, formatINR } from "@/lib/api";
import { AlertTriangle } from "lucide-react";

const AdminLowStock = () => {
  const [threshold, setThreshold] = useState(5);
  const [data, setData] = useState({ items: [] });
  useEffect(() => {
    api.get("/admin/low-stock", { params: { threshold } }).then((r) => setData(r.data)).catch(() => {});
  }, [threshold]);

  return (
    <div data-testid="admin-low-stock-page">
      <div className="flex items-end justify-between mb-6 flex-wrap gap-4">
        <div>
          <p className="font-label text-[11px] uppercase tracking-[0.22em] text-rose/70 mb-1">Catalog</p>
          <h1 className="font-hero text-3xl text-cream">Low stock alerts</h1>
          <p className="text-sm text-cream/75 mt-1">Products at or below the stock threshold.</p>
        </div>
        <div className="flex items-center gap-3">
          <span className="font-label text-[10px] uppercase tracking-[0.22em] text-cream/65">Threshold</span>
          <input
            type="number" min={0} value={threshold}
            onChange={(e) => setThreshold(Number(e.target.value))}
            className="w-20 h-10 rounded-md bg-white/5 border border-white/10 text-cream px-3 text-sm"
          />
        </div>
      </div>

      {data.items.length === 0 ? (
        <div className="rounded-2xl p-10 text-center text-cream/75" style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)" }}>
          <AlertTriangle className="mx-auto mb-3 text-rose/60" /> No items below threshold.
        </div>
      ) : (
        <div className="rounded-2xl overflow-hidden" style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)" }}>
          <table className="w-full text-sm text-cream/80">
            <thead>
              <tr className="text-left font-label text-[11px] uppercase tracking-[0.22em] text-cream/65 border-b border-white/10">
                <th className="py-3 px-4">Product</th><th>SKU</th><th>Category</th><th>Price</th><th>Stock</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((p) => (
                <tr key={p.id} className="border-b border-white/10 last:border-b-0">
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-12 rounded-md bg-white/5 overflow-hidden">
                        {p.images?.[0] && <img src={p.images[0]} alt="" className="w-full h-full object-cover" />}
                      </div>
                      <span className="font-cormorant text-base text-cream">{p.name}</span>
                    </div>
                  </td>
                  <td>{p.sku || "—"}</td>
                  <td className="capitalize">{p.category_slug}</td>
                  <td>{formatINR(p.price)}</td>
                  <td>
                    <span
                      className="font-label text-[10px] uppercase tracking-[0.22em] px-2 py-1 rounded-full"
                      style={{
                        background: p.stock === 0 ? "rgba(201,120,154,0.25)" : "rgba(212,184,150,0.18)",
                        color: p.stock === 0 ? "#E8B8CE" : "#D4B896",
                      }}
                    >
                      {p.stock === 0 ? "Out of stock" : `${p.stock} left`}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminLowStock;
